import React, { Component, Fragment } from 'react';
import { Row, Col, Button } from "reactstrap";
import { inject, observer } from 'mobx-react';
import InputSelect from '../../comum/tables/components/inputs/InputSelect';
import { E_TIPO_TELA } from '../stores/Enum';
import Card from '../../comum/components/Card';
import HelpButton from '../../comum/components/HelpButton';
import CheckboxField from '../../comum/components/CheckboxField';
import Tooltip from '../../comum/components/Tooltip';

@inject("store")
@observer
export default class FiltroServico extends Component {
    constructor(props) {
        super(props);

        this.expStore = this.props.controllers.expStore;
        this.impStore = this.props.controllers.impStore;
        this.cabStore = this.props.controllers.cabStore;
        this.traStore = this.props.controllers.traStore;
        this.remStore = this.props.controllers.remStore;
        this.filterStore = this.props.controllers.filterStore;
        this.viewStore = this.props.controllers.viewStore;
        this.modalStore = this.props.store.modalStoreCustom;
    }
    
    componentDidMount() {
        this.filterStore.fetchFilterOptions();
    }

    handleIniciarSimulacao = async () => {        
        if (this.viewStore.simulacaoAtiva){
            this.modalStore.openNewConfigurableModal('Alerta!', {
                body: <p>Deseja limpar as informações e iniciar uma nova simulação?</p>,
                okLabel: "SIM",
                cancelLabel: "NÃO",
                onClickOk: this.resetarSimulacao.bind(this),
            });
        } else {
            this.viewStore.alteraTela(this.filterStore.modalidade);
            this.expStore.clearFields();
            this.impStore.clearFields();
            this.cabStore.clearFields();
            this.remStore.clearFields();
            this.traStore.clearFields();
            this.props.replaceSearchString(this.filterStore.filters);
            this.filterStore.setQuery(this.filterStore.filters);
        }
    }

    resetarSimulacao() {
        this.filterStore.clearFilters();
        this.viewStore.alteraTela(E_TIPO_TELA.Filtro);
        this.viewStore.resetarSimulacao();
    }

    render() {
        return (
            <Fragment>
                <Row className="botoes-inclusao-topo">
                    <Col xs={12} sm={12} md={12} >
                    <HelpButton className="m-3" href="https://atendimento.teconsvonline.com.br/hc/pt-br/articles/27100081298445-Calculadora-de-Servi%C3%A7os-e-Pre%C3%A7os-Wilson-Sons-Tecon-Salvador" />
                        <Button className="mb-1 btn-com-bordas-primary" onClick={() => this.handleIniciarSimulacao() } 
                            disabled={this.viewStore.simulacaoAtiva ? false : !this.filterStore.iniciarSimulacaoEnabled} > 
                            {this.viewStore.simulacaoAtiva ? 'Cancelar Simulação' : 'Iniciar Simulação' }
                        </Button>
                    </Col>
                </Row>
                <Card className="pb-0">
                    <Row className="w-100">
                        <InputSelect xs={12} sm={12} md={6} lg={3} xl={3}
                            title="Tipo de Cliente"
                            name="TipoCliente"                            
                            options={this.filterStore.tiposClienteOptions}
                            onChange={opt => this.filterStore.setTipoCliente(opt ? opt.value : null)}
                            value={this.filterStore.tipoCliente ? this.filterStore.tiposCliente.value.find(o => o.value == this.filterStore.tipoCliente) : null}
                            loading={this.filterStore.tiposCliente.loading}
                            disabled={this.viewStore.simulacaoAtiva}
                        />
                        {this.filterStore.showEhNacional && (
                            <CheckboxField
                                className='mb-4 w-100s'
                                xs={12} sm={12} md={6} lg={3} xl={2}
                                titulo={
                                    <Tooltip tooltipText="Necessário para o cálculo de impostos" top style={{ marginTop: '-50px' }}>
                                        É Arm. Nacional?
                                    </Tooltip>
                                }
                                onClick={() => null}
                                ativo={this.filterStore.ehNacional}
                                onChange={checked => this.filterStore.setEhNacional(checked)}
                                disabled={this.viewStore.simulacaoAtiva}
                                backgroundWhite
                            /> 
                        )}
                        <InputSelect xs={12} sm={12} md={6} lg={3} xl={3}
                            title="Modalidade de Navegação"
                            name="Modalidade"                            
                            options={this.filterStore.modalidadesOptions}
                            onChange={opt => this.filterStore.setModalidade(opt ? opt.value : null)}
                            value={this.filterStore.modalidade ? this.filterStore.modalidades.value.find(o => o.value == this.filterStore.modalidade) : null}
                            loading={this.filterStore.modalidades.loading}
                            disabled={this.viewStore.simulacaoAtiva}
                        />
                        {this.filterStore.showTransbordoOption && (
                            <InputSelect xs={12} sm={12} md={6} lg={3} xl={2}
                                title="Transbordo"
                                name="TipoTransbordo"                            
                                options={this.filterStore.tiposTransbordoOptions}
                                onChange={opt => this.filterStore.setTipoTransbordo(opt ? opt.value : null)}
                                value={this.filterStore.tipoTransbordo ? this.filterStore.tiposTransbordo.value.find(o => o.value == this.filterStore.tipoTransbordo) : null}
                                loading={this.filterStore.tiposTransbordo.loading}
                                disabled={this.viewStore.simulacaoAtiva}
                            />
                        )}
                        <InputSelect xs={12} sm={12} md={6} lg={3} xl={this.filterStore.showEhNacional || this.filterStore.showTransbordoOption ? 2 : 3}
                            title="Sentido da Operação"
                            name="SentidoOperacao"                            
                            options={this.filterStore.sentidosOperacaoOptions}
                            onChange={opt => this.filterStore.setSentidoOperacao(opt ? opt.value : null)}
                            value={this.filterStore.sentidoOperacao ? this.filterStore.sentidosOperacao.value.find(o => o.value == this.filterStore.sentidoOperacao) : null}
                            loading={this.filterStore.sentidosOperacao.loading}
                            disabled={this.filterStore.disableSentidoOperacao || this.viewStore.simulacaoAtiva}
                            placeholder={this.filterStore.disableSentidoOperacao ? "Seleção automática" : ''}
                        />
                        <InputSelect xs={12} sm={12} md={6} lg={3} xl={this.filterStore.showEhNacional || this.filterStore.showTransbordoOption ? 2 : 3}
                            title="Origem da Carga"
                            name="OrigemCarga"                            
                            options={this.filterStore.origensCargaOptions}
                            onChange={opt => this.filterStore.setOrigemCarga(opt ? opt.value : null)}
                            value={this.filterStore.origemCarga ? this.filterStore.origensCarga.value.find(o => o.value == this.filterStore.origemCarga) : null}
                            loading={this.filterStore.origensCarga.loading}
                            disabled={this.filterStore.disableOrigemDaCarga || this.viewStore.simulacaoAtiva}
                            placeholder={this.filterStore.disableOrigemDaCarga ? "Seleção automática" : ''}
                        />
                    </Row>
                </Card>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/FiltroServico.js